import { connect } from 'react-redux';
import Brands from './components/Brands';

const mapStateToProps = (state) => ({
  agencyId: state.auth.profile.extend.agency.id
});

export default connect(mapStateToProps)(Brands);
